// Copyright (c) Microsoft Corporation. All rights reserved.
/**
 * Gamepad connected status changed event.
 */
export class GamepadConnectedStatusChangedEvent extends Event {
    constructor() {
        super(GamepadConnectedStatusChangedEvent.type);
    }
}
GamepadConnectedStatusChangedEvent.type = 'gamepadConnectedStatusChanged';
//# sourceMappingURL=GamepadConnectedStatusChangedEvent.js.map